/**
 * Hooks para Categorías y Actividades del Evento.
 */

import { useEffect, useState } from "react";
import {
  subscribeToActivities,
  subscribeToCategories,
  subscribeToScoresByEvent,
} from "@/lib/services/eventActivities";
import type {
  ClubActivityScore,
  EventActivity,
  EventActivityCategory,
} from "@/types";

export function useEventActivityCategories(eventId: string | undefined) {
  const [data, setData] = useState<EventActivityCategory[] | undefined>(
    undefined,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventId) {
      setData([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    const unsub = subscribeToCategories(
      eventId,
      (items) => {
        setData(items);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      },
    );
    return unsub;
  }, [eventId]);

  return { data, isLoading, error };
}

export function useEventActivities(eventId: string | undefined) {
  const [data, setData] = useState<EventActivity[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventId) {
      setData([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    const unsub = subscribeToActivities(
      eventId,
      (items) => {
        setData(items);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      },
    );
    return unsub;
  }, [eventId]);

  return { data, isLoading, error };
}

export function useEventActivityScores(eventId: string | undefined) {
  const [data, setData] = useState<ClubActivityScore[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventId) {
      setData([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    const unsub = subscribeToScoresByEvent(
      eventId,
      (items) => {
        setData(items);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      },
    );
    return unsub;
  }, [eventId]);

  return { data, isLoading, error };
}
